import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography, Paper, Alert } from '@mui/material';
import { authAPI } from '../../utils/api';

export default function EmployeeLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await authAPI.login({ login: username, password });
      const user = res.data.user || res.data;
      if (user.user_type === 'staff' || user.user_type === 'admin') {
        localStorage.setItem('employee_access_token', res.data.access);
        localStorage.setItem('employee_refresh_token', res.data.refresh);
        localStorage.setItem('employee_user', JSON.stringify(user));
        navigate('/employee/progress-overview');
      } else {
        setError('Only staff accounts can login');
      }
    } catch (err) {
      setError('Username or password is incorrect');
    }
  };

  return (
    <Box maxWidth={400} mx="auto" my={8}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: 'background.paper' }}>
        <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 700, textAlign: 'center' }}>
          staff login
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            label="username"
            fullWidth
            margin="normal"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
          />
          <TextField
            label="password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 3 }}>
            login
          </Button>
        </Box>
      </Paper>
    </Box>
  );
} 